import { CloseSharp } from "@mui/icons-material";
import { Button, FormLabel, Grid, Stack } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { Form, Formik } from 'formik';
import { useDispatch } from 'react-redux';
import { subscriptionPayment } from "../../pages/subscriptions/action";
import Schema from "../../schema";
import NumberInput from "../inputs/normalInput/number";
import addMoneyBackground from '../../assets/images/addMoneyModalBackground.svg'
import addMoneyIcon from '../../assets/images/icons/addmoneyIcon.gif'
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(0),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(0),
    },
    '& .MuiPaper-root': {
        width: '487px',
        height: '260px',
        border: '0px solid red',
        padding:'20px',
        BorderRadius:'10px',
        backgroundImage:`url(${addMoneyBackground})`,
        backgroundRepeat:'no-repeat',
        backgroundPosition:'left bottom',
        position:'relative',
        "&::before":{
            content:'""',
            display: 'block',
            borderRadius:'0px 0px 100px 100px',
            position:'absolute',
            width:'184px', height:'6px', background:'#22C55E', zIndex: 1,top:'0%',left:'50%' ,transform:'translate(-50%)'
        }
    },
}));

export default function AddMoney(props) {
    const { open, setOpen } = props;
    const handleClose = () => setOpen(false);

    const dispatch = useDispatch();


    return (
        <>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}

            >
                <Stack
                    direction="row"
                    justifyContent={"space-between"}
                    alignItems={"center"}
                    className="pb-3"
                >
                    <Typography
                        sx={{fontWeight:'600',fontSize:'24px',fontFamily:'var(--family2)',display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center'}}
                        id="customized-dialog-title"
                    >
                        <img src={addMoneyIcon} alt="addMoneyIcon" pause style={{width:'34px',height:'34px',}}/>&nbsp;Add Money
                    </Typography>
                    <div className="cursorPointer" onClick={handleClose}>
                        <CloseSharp sx={{ color: "#000", fontSize: '20px', fontWeight: '600' }} />
                    </div>
                </Stack>
                <hr />
                <DialogContent className="pt-3">
                    <Formik
                        initialValues={{ amount: "", description: "" }}
                        enableReinitialize={true}
                        validateOnChange={true}
                        validationSchema={Schema.BidNegotiate}
                        onSubmit={(values, { setSubmitting }) => {
                            dispatch(subscriptionPayment({ amount: String(values.amount), type: "" }));
                            setOpen(false);
                        }}
                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values,
                            setFieldValue,
                            isValid,
                            dirty,
                        }) => {
                            return (
                                <Form
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        handleSubmit(e);
                                    }}
                                >
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} lg={12} md={12} sm={12}>
                                            <FormLabel required>Enter Amount(₹)</FormLabel>
                                            <NumberInput
                                                name={"amount"}
                                                type={"number"}
                                                focused={false}
                                                label={("")}
                                                sizeval="medium"
                                                values={values.amount}
                                                placeholder={"Enter Amount(₹)"}
                                                onChange={handleChange}
                                                style={{
                                                    "& .MuiInputBase-root":{

                                                        paddingLeft:'10px'
                                                    },
                                                    "& .MuiOutlinedInput-input":{
                                                        color:'#0A0A0B !important',fontSize:'14px',fontWeight:'600 !important',padding:'0px 5px'
                                                    },
                                                }}
                                                className="pt-1"
                                                startAdornment={true}
                                                startAdornmentText={<span style={{ marginRight: 0, fontWeight: '600', fontSize:'14px',color:'#0A0A0B', }}>₹</span>}
                                                //onBlur={handleBlur}
                                                error={Boolean(touched.amount) && errors.amount}
                                                helperText={touched.amount && errors.amount}

                                            />
                                        </Grid>
                                    </Grid>
                                    <DialogActions>
                                        <Stack direction={"row"} gap={2} mt={4}>
                                            <Button  sx={{width:'126px',height:'48px',padding:'12px 10px',borderRadius:'50px',color:'black'}} onClick={handleClose}>Cancel</Button>
                                            <Button variant="contained" sx={{width:'126px',height:'48px',padding:'12px 10px',borderRadius:'50px'}} disabled={!(isValid && dirty)} type="submit">Proceed</Button>
                                        </Stack>
                                    </DialogActions>
                                </Form>
                            );
                        }}
                    </Formik >

                </DialogContent>

            </BootstrapDialog>

        </>
    );
}
